<template>
  <div class="lf-page">

    <!-- Hero -->
    <div class="lf-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-receipt-text-outline</v-icon>
        </v-avatar>
        <div>
          <div class="lf-hero__title">Listado de Facturas</div>
          <div class="lf-hero__sub">Consulta por período, NIT y estado</div>
        </div>
      </div>
      <div class="d-flex align-center" style="gap:8px; flex-wrap:wrap;">
        <v-btn v-if="vermomentaneo()" icon dark small @click="openUpiMomentaneoFact()">
          <v-icon>mdi-information-outline</v-icon>
        </v-btn>
        <v-chip small color="rgba(255,255,255,0.15)" dark>
          <v-icon left small>mdi-bank-outline</v-icon> Facturación
        </v-chip>
        <v-btn small dark text @click="$router.back()">
          <v-icon left small>mdi-arrow-left</v-icon> Volver
        </v-btn>
      </div>
    </div>

    <div class="lf-body">

      <!-- Filtros -->
      <v-card outlined class="lf-filters-card mb-4">
        <v-card-title class="lf-filters-card__title py-2 px-4">
          <v-icon small color="indigo darken-2" class="mr-1">mdi-filter-outline</v-icon>
          Parámetros de consulta
        </v-card-title>
        <v-card-text class="pt-3 pb-3 px-4">
          <v-row dense align="center">
            <v-col cols="12" sm="2">
              <v-select label="Gestión" v-model="gestion" :items="gestiones"
                outlined hide-details dense prepend-inner-icon="mdi-calendar-range" />
            </v-col>
            <v-col cols="12" sm="3">
              <v-select label="Mes" v-model="mes" :items="meses" item-value="id" item-text="mes"
                outlined hide-details dense prepend-inner-icon="mdi-calendar-month-outline" />
            </v-col>
            <v-col cols="12" sm="3">
              <v-select label="NIT" v-model="nit" :items="xnitsbysucursal" item-text="nro" return-object
                :disabled="xnitsbysucursal.length == 1"
                outlined hide-details dense prepend-inner-icon="mdi-office-building" />
            </v-col>
            <v-col cols="12" sm="2">
              <v-select label="Estado" v-model="estadofact"
                :items="[{v:'V',t:'Válidas'},{v:'A',t:'Anuladas'},{v:'T',t:'Todas'}]"
                item-value="v" item-text="t"
                outlined hide-details dense prepend-inner-icon="mdi-check-circle-outline" />
            </v-col>
            <v-col cols="12" sm="2">
              <div v-if="nit" class="lf-sucursal-info">
                <v-icon x-small color="indigo darken-2" class="mr-1">mdi-map-marker-outline</v-icon>
                <span>{{ nit.sucursal.ciudad }} — {{ nit.sucursal.direccion }}</span>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Tabla -->
      <v-card outlined class="lf-table-card">

        <!-- Toolbar de la tabla -->
        <div class="lf-table-toolbar px-4 py-2 d-flex align-center flex-wrap" style="gap:8px;">
          <v-text-field
            v-show="facturas.length"
            v-model="buscar"
            dense outlined hide-details clearable
            placeholder="Buscar en la tabla..."
            prepend-inner-icon="mdi-magnify"
            style="max-width:300px;"
          />
          <v-spacer />
          <v-chip x-small :color="facturas.length ? 'indigo lighten-5' : 'grey lighten-3'"
            class="indigo--text text--darken-2 font-weight-medium">
            {{ facturas.length }} registro{{ facturas.length !== 1 ? 's' : '' }}
          </v-chip>
          <v-btn v-if="facturas.length > 0" small color="purple darken-1" dark depressed @click="openFacturaPrintMas()">
            <v-icon left small>mdi-download</v-icon> Descargar todos
          </v-btn>
        </div>

        <v-divider />

        <p v-if="msg" class="text-center red--text ma-2" style="font-size:0.85rem;">{{ msg }}</p>

        <v-data-table
          :headers="headers"
          :items="facturas"
          :loading="loading"
          :search="buscar"
          :item-class="rowClass"
          dense
          loading-text="Cargando facturas..."
          no-data-text="Sin facturas. Seleccione los filtros para consultar."
          class="lf-table"
        >
          <!-- Estado -->
          <template v-slot:[`item.estado`]="{ item }">
            <v-chip x-small label
              :color="item.estado === 'A' ? 'red lighten-5' : 'green lighten-5'"
              :class="item.estado === 'A' ? 'red--text text--darken-2' : 'green--text text--darken-2'">
              <v-icon left x-small>{{ item.estado === 'A' ? 'mdi-close-circle-outline' : 'mdi-check-circle-outline' }}</v-icon>
              {{ item.estado === 'A' ? 'Anulada' : 'Válida' }}
            </v-chip>
          </template>

          <!-- Opciones -->
          <template v-slot:[`item.opciones`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon x-small color="green darken-1" v-on="on" @click="openFacturaPrint(item.id)">
                  <v-icon x-small>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>Descargar factura</span>
            </v-tooltip>

            <v-menu left :close-on-content-click="false" offset-x tile max-width="560">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon x-small color="indigo darken-1" v-bind="attrs" v-on="on" class="ml-1">
                  <v-icon x-small>mdi-eye-outline</v-icon>
                </v-btn>
              </template>

              <v-card class="lf-detail-card" width="560">
                <div class="lf-detail-header px-4 py-3">
                  <span class="white--text font-weight-bold" style="font-size:0.9rem;">
                    <v-icon color="white" small class="mr-1">mdi-file-document-outline</v-icon>
                    Detalle de la factura
                  </span>
                </div>
                <v-divider />
                <v-card-text class="pa-3">
                  <v-row dense>
                    <v-col cols="12" sm="4">
                      <div class="lf-drow"><span class="lf-dk">Especificación</span><span class="lf-dv">{{ item.especificacion }}</span></div>
                      <div class="lf-drow"><span class="lf-dk">Nro</span><span class="lf-dv">{{ item.nro }}</span></div>
                      <div class="lf-drow"><span class="lf-dk">Fecha</span><span class="lf-dv">{{ item.fecha }}</span></div>
                      <div class="lf-drow"><span class="lf-dk">Fecha lím. emisión</span><span class="lf-dv">{{ item.fecha_limite_emision }}</span></div>
                      <div class="lf-drow"><span class="lf-dk">Fecha registro</span><span class="lf-dv">{{ item.fecha_registro }}</span></div>
                      <div class="lf-drow"><span class="lf-dk">Hora</span><span class="lf-dv">{{ item.hora }}</span></div>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <div class="lf-drow"><span class="lf-dk">Nro factura</span><span class="lf-dv">{{ item.numero_factura }}</span></div>
                      <div class="lf-drow"><span class="lf-dk">Nro autorizacion</span><span class="lf-dv">{{ item.numero_autorizacion }}</span></div>
                      <div class="lf-drow"><span class="lf-dk">Estado</span><span class="lf-dv">{{ item.estado }}</span></div>
                      <div class="lf-drow"><span class="lf-dk">NIT cliente</span><span class="lf-dv">{{ item.nit_cliente }}</span></div>
                      <div class="lf-drow"><span class="lf-dk">NIT empresa</span><span class="lf-dv">{{ item.nit_empresa }}</span></div>
                      <div class="lf-drow"><span class="lf-dk">Razón social</span><span class="lf-dv">{{ item.razon_social }}</span></div>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <div class="lf-drow"><span class="lf-dk">Imp. total venta</span><span class="lf-dv">{{ item.importe_total_venta }}</span></div>
                      <div class="lf-drow"><span class="lf-dk">Importe IVA</span><span class="lf-dv">{{ item.importe_iva }}</span></div>
                      <div class="lf-drow"><span class="lf-dk">Exportaciones</span><span class="lf-dv">{{ item.exportaciones }}</span></div>
                      <div class="lf-drow"><span class="lf-dk">Ventas tasa cero</span><span class="lf-dv">{{ item.ventas_tasa_cero }}</span></div>
                      <div class="lf-drow"><span class="lf-dk">Subtotal</span><span class="lf-dv">{{ item.subtotal }}</span></div>
                      <div class="lf-drow"><span class="lf-dk">Descuentos IVA</span><span class="lf-dv">{{ item.descuentos_iva }}</span></div>
                      <div class="lf-drow"><span class="lf-dk">Importe fiscal</span><span class="lf-dv">{{ item.importe_fiscal }}</span></div>
                      <div class="lf-drow"><span class="lf-dk">Débito fiscal</span><span class="lf-dv">{{ item.debito_fiscal }}</span></div>
                      <div class="lf-drow"><span class="lf-dk">Cód. control</span><span class="lf-dv">{{ item.codigo_control }}</span></div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-menu>
          </template>
        </v-data-table>

        <FacturasDownload v-if="!$store.state.isonlyread" :facturas="facturas" :datosdescarga="datosdescargas" />
      </v-card>

    </div>

    <print-factura :programa_id="null" ref="refFacturaPrint" />
    <PrintFacturaMas :programa_id="null" ref="refFacturaPrintMas" />
    <momentanea_upi ref="refmomentanea_upi" />
  </div>
</template>

<script>
  import FacturasDownload from '@/components/facturastoexcel.vue';
  import { getheadersrest } from '@/components/Utils';
  import gql from 'graphql-tag';
  import PrintFactura from './recibos/PrintFactura.vue';
  import PrintFacturaMas from './recibos/PrintFacturaMas.vue';
  import momentanea_upi from '@/views/upi/factura_upi/momentanea_upi.vue';

  export default {
    data() {
      return {
        api_rest: process.env.VUE_APP_API_REST,
        sede: null,
        deltatam: 0,
        msg: '',
        loading: false,
        datosdescargas: {},
        seleccionado: {},
        nits: [],
        sucursales: [],
        sucursalesbysede: [],
        xnitsbysucursal: [],
        facturas: [],
        nics: [],
        nit: null,
        estadofact: 'V',
        busqueda: {
          fecha_ini: null,
          fecha_fin: null,
        },
        mes: null,
        gestion: null,
        meses: [
          { id: 1, mes: 'Enero' },
          { id: 2, mes: 'Febrero' },
          { id: 3, mes: 'Marzo' },
          { id: 4, mes: 'Abril' },
          { id: 5, mes: 'Mayo' },
          { id: 6, mes: 'Junio' },
          { id: 7, mes: 'Julio' },
          { id: 8, mes: 'Agosto' },
          { id: 9, mes: 'Septiembre' },
          { id: 10, mes: 'Octubre' },
          { id: 11, mes: 'Noviembre' },
          { id: 12, mes: 'Diciembre' },
        ],
        gestiones: [2027,2026,2025,2024, 2023, 2022, 2021, 2020],
        buscar: '',
        headers: [
          { text: '#',           value: 'nro',                  width: '50',  sortable: false },
          { text: 'No. Factura', value: 'numero_factura',        width: '110' },
          { text: 'NIT Cliente', value: 'nit_cliente',           width: '110' },
          { text: 'NIT Empresa', value: 'nit_empresa',           width: '110' },
          { text: 'Cliente',     value: 'nombre_cliente' },
          { text: 'Imp. Total',  value: 'importe_total_venta',   width: '110' },
          { text: 'No. Auth',    value: 'numero_autorizacion' },
          { text: 'Estado',      value: 'estado',                width: '100' },
          { text: 'Opciones',    value: 'opciones',              width: '80',  sortable: false },
        ],
      };
    },
    components: { FacturasDownload, PrintFactura, PrintFacturaMas, momentanea_upi },
    watch: {
      '$store.state.CARGO': function() {
        this.sede = this.$store.state.CARGO.idsede;
        this.facturas = [];
        this.sucursal = {};
        this.nit = null;
        this.getsucursalesall();
      },
      gestion: function() {
        this.evento_filtros();
      },
      mes: function() {
        this.evento_filtros();
      },
      nit: function() {
        this.evento_filtros();
      },
      'sucursal.id': function() {
        this.evento_filtros();
      },
      estadofact: function() {
        this.evento_filtros();
      },
    },
    methods: {
      rowClass(item) {
        return item.estado === 'A' ? 'lf-row--anulada' : '';
      },
      editar(obj) {
        this.seleccionado = obj;
      },
      modalExitof() {},
      parsesede(s) {
        if (!s) return;
        let guion = s.indexOf('-') + 2;
        return s.substring(guion, s.length);
      },
      async getDatos(datosserver) {
        const vue = this;
        datosserver.forEach(function(dem) {
          let fs = dem.fecha.split('-');
          dem.importe_total_venta = dem.monto;
          dem.subtotal = dem.monto;
          dem.importe_fiscal = dem.monto;
          dem.especificacion = 3;
          dem.importe_iva = 0;
          dem.exportaciones = 0;
          dem.ventas_tasa_cero = 0;
          dem.descuentos_iva = 0;
          dem.nro = vue.facturas.length + 1;
          dem.fecha_slash = `${fs[2]}/${fs[1]}/${fs[0]}`;
          dem.nombre_cliente = dem.nombre_cliente.toUpperCase();

          if (dem.estado == 'ANULADA') dem.nombre_cliente = '';
          if (dem.estado == 'ANULADA') dem.nit_cliente = 0;
          if (dem.estado == 'ANULADA') dem.importe_total_venta = 0;
          if (dem.estado == 'ANULADA') dem.subtotal = 0;
          if (dem.estado == 'ANULADA') dem.debito_fiscal = 0;
          if (dem.estado == 'ANULADA') dem.importe_fiscal = 0;
          if (dem.estado == 'ANULADA') dem.razon_social = 'ANULADA';

          if (dem.estado == 'ANULADA') dem.estado = 'A';
          else if (dem.estado == 'VALIDA') dem.estado = 'V';

          vue.facturas.push(dem);
        });
      },
      getfechasrango() {
        let date_inicio = new Date();
        date_inicio.setDate(1);
        date_inicio.setFullYear(this.gestion);
        date_inicio.setMonth(this.mes - 1);

        let date_final = new Date();
        date_final.setDate(1);
        date_final.setMonth(this.mes);
        date_final.setFullYear(this.gestion);
        date_final.setDate(date_final.getDate() - 1);

        let d1 = '01';
        let m1 = date_inicio.getMonth() + 1;
        let y1 = date_inicio.getFullYear();
        let d2 = date_final.getDate();
        let m2 = date_final.getMonth() + 1;
        if (m1 < 10) m1 = '0' + m1;
        if (d2 < 10) d2 = '0' + d2;
        if (m2 < 10) m2 = '0' + m2;
        return `&fecha_inicio=${d1}/${m1}/${y1}&fecha_fin=${d2}/${m2}/${y1}`;
      },
      getDatosFacturas() {
        const vue = this;
        vue.loading = true;
        vue.msg = '';
        let myHeaders = getheadersrest();
        let url = `${this.api_rest}/api/pagos/facturas?sucursal_id=${this.nit.sucursal.id}${this.getfechasrango()}`;
        if (this.estadofact != 'T') url += `&estado=${this.estadofact}`;

        let requestOptions = { method: 'GET', headers: myHeaders };
        window.console.log(myHeaders, url);

        fetch(url, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (!result) result = [];
            vue.getDatos(result);
            vue.loading = false;
            if (result.length == 0) {
              vue.msg = 'No se han encontrado facturas según los datos de búsqueda ingresados.';
            }
          })
          .catch(() => {
            vue.loading = false;
          });
      },
      correcionfront(data) {
        const result = [];
        const vue = this;
        data.forEach((item) => {
          try {
            vue.deltatam = parseInt(data[0].numero_factura);
          } catch (e) {
            window.console.log(e);
          }
          let d = result.find((x) => x.numero_factura == item.numero_factura);
          if (d && d.estado == 'ANULADA') {
            d.importe_fiscal = '0';
            d.importe_total_venta = '0';
            d.debito_fiscal = '0';
            d.subtotal = '0';
          }
          item.razon_social = item.nombre_cliente + '';
          if (!d) result.push(item);
        });
        return result;
      },
      evento_filtros() {
        if (!this.nit || !this.nit.id) return;
        if (!this.mes) return;
        if (!this.gestion) return;
        let m = this.meses.find((x) => x.id == this.mes).mes;
        let filename = `${this.nit.nro}-${this.nit.sucursal.id}-${this.gestion}-${m}`;
        this.datosdescargas.filename = filename;
        this.facturas = [];
        this.getDatosFacturas();
      },
      getsucursalesall() {
        const vue = this;
        vue.nits = [];
        vue.sucursales = [];
        vue.sucursalesbysede = [];
        vue.loading = true;
        vue.nics = [];
        let qs = gql`
          query {
            getNits {
              id nombre descripcion nro estado
            }
            getSucursalesByIdSede(id:${vue.sede}) {
              id nit_id direccion telefono ciudad numero_sucursal
            }
          }
        `;
        this.$apollo
          .query({ query: qs })
          .then((data) => {
            if (!data.data.getSucursalesByIdSede) data.data.getSucursalesByIdSede = [];
            vue.nits = data.data.getNits;
            vue.sucursales = data.data.getSucursalesByIdSede;
            vue.sucursalesbysede = vue.sucursales;
            vue.sucursalesbysede.forEach((x) => {
              let nitss = vue.nits.filter((n) => n.id == x.nit_id);
              nitss.forEach((j) => {
                let existe = vue.nics.find((x) => x.id == j.id);
                if (!existe) vue.nics.push(j);
              });
            });
            vue.xnitsbysucursal = [];
            vue.nics.forEach((x) => {
              let pertenece = vue.sucursalesbysede.find((s) => s.nit_id == x.id);
              if (pertenece) {
                x.sucursal = pertenece;
                vue.xnitsbysucursal.push(x);
              }
            });
            vue.loading = false;
            if (vue.nics.length == 1) {
              vue.nit = vue.nics[0];
            }
            if (vue.sucursalesbysede.length == 1) {
              if (!vue.nit.id) vue.nit = vue.nics[0];
              let anio = new Date().getFullYear();
              let mess = new Date().getMonth() + 1;
              vue.gestion = anio;
              vue.mes = mess;
              vue.sucursal = vue.sucursalesbysede[0];
            }
          })
          .catch((error) => {
            window.console.error(error);
          });
      },
      openFacturaPrint(factura_id, recibo) {
        this.$refs.refFacturaPrint.showThisView(factura_id, recibo);
      },
      openFacturaPrintMas() {
        this.$refs.refFacturaPrintMas.showThisView(this.facturas);
      },
      vermomentaneo() {
        const users = this.$store.state.DATA_USER.id == 43 || this.$store.state.DATA_USER.id == 114112 || this.$store.state.DATA_USER.id == 136449 || this.$store.state.DATA_USER.id == 137077 || this.$store.state.DATA_USER.id == 137075 || this.$store.state.DATA_USER.id == 26164;
        const sedeid = this.$store.state.CARGO.sede.id == 82;
        return users && sedeid;
      },
      openUpiMomentaneoFact() {
        this.$refs.refmomentanea_upi.openmodal();
      },
    },
    mounted() {
      this.sede = this.$store.state.CARGO.idsede;
      let anio = new Date().getFullYear();
      let mess = new Date().getMonth() + 1;
      this.gestion = anio;
      this.mes = mess;
      this.getsucursalesall();
    },
  };
</script>

<style scoped>
.lf-page { min-height: 100vh; background: #f5f7fa; }

.lf-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.lf-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.lf-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.lf-body { padding: 20px 24px; }

.lf-filters-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }
.lf-filters-card__title {
  font-size: 0.8rem !important; font-weight: 700 !important;
  color: #283593; letter-spacing: 0.02em; border-bottom: 1px solid #e8edf7;
}

.lf-sucursal-info {
  font-size: 0.75rem; color: #455a64;
  display: flex; align-items: center;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}

.lf-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.lf-table-toolbar { background: #fafbff; border-bottom: 1px solid #e8edf7; }

.lf-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.lf-table >>> tbody tr:hover { background: #f0f4ff !important; }
.lf-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 4px 12px !important;
}
.lf-table >>> tbody tr.lf-row--anulada { background: #FCCDCD !important; }
.lf-table >>> tbody tr.lf-row--anulada:hover { background: #f9b7b7 !important; }

.lf-detail-card { border-radius: 8px !important; overflow: hidden; }
.lf-detail-header {
  background: linear-gradient(120deg, #1a237e 0%, #283593 100%);
  padding: 10px 16px;
}

.lf-drow {
  display: flex;
  gap: 4px;
  margin-bottom: 4px;
  font-size: 0.78rem;
  line-height: 1.4;
}
.lf-dk {
  color: #78909c;
  min-width: 110px;
  flex-shrink: 0;
}
.lf-dv {
  color: #263238;
  font-weight: 500;
  word-break: break-all;
}
</style>
